module.exports = __webpack_public_path__ + "img/bms2.d5cef6ba.png";